<template lang="pug">
div.item-sign-in-with-email
  //- div(v-if="status == 'start'").sign-in-btn.cursor-pointer.rounded.pl16.pr18.py10.f.fm
    v-icon(size="28px" color="white").mr10 mdi-email
    span(@click="onStartSignIn").bold {{($route.name == 'sign-in') ? 'Sign in with Email' : 'Sign up with Email' }}
  div(v-if="status == 'ask_email'").ask-email
    v-text-field(v-if="$route.name == 'sign-up'"
      v-model="name" label="ユーザー名"
      placeholder="ユーザー名を入力"
      persistent-placeholder outlined)
    v-text-field(v-model="email"
      label="email"
      placeholder="emailアドレスを入力"
      :rules="rulesEmail"
      @keypress.enter="signInWithEmail"
      persistent-placeholder outlined)
    v-text-field(v-model="password"
      label="パスワード"
      placeholder="半角英数字8文字以上"
      hint="半角英数字8文字以上"
      :rules="form.rules"
      :counter="!noValidation"
      :append-icon="togglePwIcon.icon"
      :type="togglePwIcon.type"
      autocomplete="on"
      @click:append="showPwIcon = !showPwIcon"
      @keypress.enter="signInWithEmail"
      persistent-placeholder outlined)
    div(v-if="$route.name == 'sign-up'").wrap-check-box.f.fc
      div.f.fm
        v-checkbox(v-model="agreePolicy")
        span.fz12.pb4 #[a(:href="privacyPolicy" target="blank").fz12 利用規約]・#[a(:href="serviceTerms" target="blank").fz12 個人情報保護方針]に同意
    div.mt20
      Button(:label="$route.name == 'sign-in' ? 'ログイン' : 'アカウントを登録'"
        :action="signInWithEmail" :active="enableSignIn" :isSaving="isLoading")
      //- span(@click="onCancel").cancel.mr16 Cancel
      //- v-btn(@click="signInWithEmail"
        :color="enableSignIn ? pallete.$active_color : pallete.$deactive_color"
        dark) {{(this.$route.name == 'sign-in') ? 'サインイン' : 'サインアップ'}}
  div(v-if="status == 'check_verification'").check-validation
    span.block.mb4 {{email}}に
    span.block.mb8 確認メールを送信しました。受信箱をご確認ください
    span.block.fz12.mb18 * メールの送信に時間がかかることがあります
    div.f.flex-right.mb20
      span(:class="{'active' : !isSendingVerificationEmail}" @click="resendVerification"
        ).btn-send-verification.fz14.cursor-pointer 確認メールを再送信
</template>

<style scoped lang="scss">
@import "@/scss/_variables.scss";

.item-sign-in-with-email {
  .sign-in-btn {
    background: $dark_primary_bg_color;
    width: 228px;
    span {
      color: #fff;
    }
  }
  .ask-email {
    width: 280px;
    .cancel {
      color: $secondary_text_color;
    }
    .wrap-check-box {
      a {
        color: $tertiary_active_color !important;
        border-bottom:  $basic_border_bold;
      }
    }
  }
  .check-validation {
    width: 280px;
    .btn-send-verification {
      color: $deactive_color;
      &.active {
        color: $active_color;
      }
    }
  }
}

// .v-input--selection-controls {
//   margin-top: 0;
//   padding-top: 0;
// }
</style>

<script>
import database from '@/database'
import { firebase, auth, functions } from '@/components/utils/firebase'
import { domain } from '@/components/utils/config'
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('auth')
import { identifyMixpanelUser, createMixpanelUser } from '@/components/utils/mixpanel'
import Button from '@/components/shared/Button'

export default {
  components: {
    Button
  },
  data () {
    return {
      status: 'ask_email',
      name: '',
      email: '',
      password: '',
      rulesEmail: [
        v => !!v || '',
        v => /.+@.+\..+/.test(v) || ''
      ],
      showPwIcon: false,
      noValidation: true,
      enableSignIn: false,
      isLoading: false,
      isSendingVerificationEmail: false,
      agreePolicy: false,
      privacyPolicy: '/privacy_policy.pdf',
      serviceTerms: '/terms_terms.pdf'
    }
  },
  computed: {
    form () {
      const min = '半角英数字8文字以上'
      const msg = `${min}`
      const required = v => !!v || ''
      const format = v => /^[\w-]{8,72}$/.test(v) || msg

      const rules = this.noValidation ? [required] : [format]
      const hint = this.noValidation ? undefined : msg
      const placeholder = this.noValidation ? undefined : min
      return { rules, hint, placeholder }
    },
    togglePwIcon () {
      const icon = this.showPwIcon ? 'mdi-eye' : 'mdi-eye-off'
      const type = this.showPwIcon ? 'text' : 'password'
      return { icon, type }
    }
  },
  watch: {
    name () {
      this.formValidation()
    },
    email () {
      this.formValidation()
    },
    password () {
      this.noValidation = (this.password === '') ? true : false
      this.formValidation()
    },
    agreePolicy () {
      this.formValidation()
    },
    '$route': function (to) {
      this.formValidation()
    }
  },
  async created () {
    firebase.auth().getRedirectResult().then(async (result) => {
      // console.log('result', result)
      if (result.providerId == 'password') {
        // console.log('result2', result)
      }
      // if (result.credential) {
      //   this.setUnderLoading(true)
      //   if (result.credential.signInMethod === 'facebook.com') {
      //     // This gives you a Facebook Access Token. You can use it to access the Facebook API.
      //     const token = result.credential.accessToken
      //     this.signUp(token)
      //   }
      // }
    })
  },
  methods: {
    ...mapActions(['setUnderLoading']),
    async signInWithEmail () {
      if (!this.enableSignIn || this.isLoading) return
      this.isLoading = true

      this.setUnderLoading(true)
      const providers = await auth.fetchSignInMethodsForEmail(this.email)
      // console.log('providers', providers)

      if (providers[0] && this.$route.name == 'sign-up') {
        this.$root.$emit('showNavigationMessage', {
          message: 'アカウントがすでに登録されています。サインインしてください',
        })
        this.$router.push('/sign-in')
        this.setUnderLoading(false)
        this.isLoading = false
        return
      }
      // アカウントがないか、emailでログインしたことがあれば処理する
      let res
      if (!providers[0]
      || providers.findIndex(p => p === firebase.auth.EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD) !== -1) {
        if (!providers[0]) { // sign up
          if (this.$route.name === 'sign-in') {
            this.$root.$emit('showNavigationMessage', {
              message: '未登録のメールアドレスです', showOK: true
            })
            this.setUnderLoading(false)
            this.isLoading = false
            return
          }
          await auth.createUserWithEmailAndPassword(this.email, this.password)
          res = await auth.signInWithEmailAndPassword(this.email, this.password)

          if (res.status === 'error') {
            // alert(res.message)
            console.log('error:', res.message)
            this.$root.$emit('showNavigationMessage', {
              message: 'Emailもしくはパスワードをご確認ください', showOK: true
            })
            this.setUnderLoading(false)
            this.isLoading = false
            return
          }
          // const userObj = {
          //   uid: res.user.uid,
          //   name: this.name,
          //   profile: '',
          //   followerUsers: [],
          //   followingUsers: [],
          //   followingComics: [],
          //   followingAssets: [],
          //   favoriteAssets: [],
          //   followerUsersNum: 0,
          //   followingUsersNum: 0,
          //   followingComicsNum: 0,
          //   followingAssetsNum: 0,
          //   favoriteAssetsNum: 0,
          //   websites: {},
          //   notificationSettings: {
          //     // アクティビティ
          //     your_asset_is_added_to_favorite: true,
          //     your_asset_is_followed: true,
          //     your_comic_is_followed: true,
          //     you_are_followed: true,
          //     your_post_is_liked: true,
          //     your_post_gets_new_comment: true,
          //     your_comment_gets_new_like: true,
          //     your_following_user_creates_new_post: true,
          //     your_following_comic_is_updated: true,
          //     // レポート
          //     your_comic_gets_hight_page_views_num: true,
          //     // その他
          //     notification_from_comicaroid_team: true
          //   },
          //   readNotificationAt: new Date(),
          //   unreadNotificationNum: 0,
          //   createdAt: new Date(),
          //   updatedAt: new Date()
          // }
          // await database.userCollection().signUp(userObj)
        } else { // sign in
          res = await auth
            .signInWithEmailAndPassword(this.email, this.password)
            .catch((error) => {
              error.status = 'error'
              return error
            })
          if (res.status === 'error') {
            // alert(res.message)
            console.log('error:', res.message)
            this.$root.$emit('showNavigationMessage', {
              message: 'Emailもしくはパスワードをご確認ください', showOK: true
            })
            this.setUnderLoading(false)
            this.isLoading = false
            return
          }
        }
        // console.log('res', res)

        // const path = (this.$route.params.redirectPath) ? 
        //   decodeURIComponent(this.$route.params.redirectPath)
        //   : `/user/${res.user.uid}`
        // this.$router.push(path)
        
        // メール認証を行う場合
        if (res.user.emailVerified) {
          const userDoc = await database.userCollection().findById(res.user.uid)
          if (!userDoc) {
            const currentUser = await auth.currentUser
            const name = this.name ? this.name : currentUser.displayName ? currentUser.displayName : ''
            await res.user.updateProfile({ displayName: name })
            await currentUser.getIdToken(true)
            const createVerifiedUser = functions.httpsCallable('createVerifiedUser')
            const verifiedNewUser = await createVerifiedUser({ name })
              .then(result => result.data)
            createMixpanelUser({ user: verifiedNewUser, email: currentUser.email })
            // console.log('verifiedNewUser:', verifiedNewUser)
            if (!verifiedNewUser) return
          }
          // console.log('Email has been verified')
          identifyMixpanelUser(res.user.uid)
          const path = (this.$route.params.redirectPath) ? 
            decodeURIComponent(this.$route.params.redirectPath)
            : `/user/${res.user.uid}`
          this.$router.push(path)
        } else {
          try {
            await res.user.updateProfile({ displayName: this.name })
            const actionCodeSettings = {
              url: `${domain}/finish-email-validation`,
              // url: `${domain}/finish-email-validation/${res.user.uid}`,
              handleCodeInApp: false
            }
            // console.log('actionCodeSettings', actionCodeSettings)
            await res.user.sendEmailVerification(actionCodeSettings)
            this.status = 'check_verification'
          } catch (e) {
            let message = 'エラーが発生しました'
            if (e.code === 'auth/too-many-requests') {
              message = '試行回数の上限を超えました。しばらくしてから再度お試しください'
            }
            console.error(e)
            this.$root.$emit('showNavigationMessage', {
              message, showOK: true
            })
          }
        }
      }
      //  else {
      //   this.$root.$emit('showNavigationMessage', {
      //     message: 'このEmailはすでに登録済みです。ログインしてください', showOK: true
      //   })
      //   this.$router.replace('/sign-in')
      // }
      this.setUnderLoading(false)
      this.isLoading = false
    },
    async resendVerification () {
      this.isSendingVerificationEmail = true
      const user = firebase.auth().currentUser
      try {
        const credential = firebase.auth.EmailAuthProvider.credential(
          this.email,
          this.password
        )
        await user.reauthenticateWithCredential(credential).then()
        const actionCodeSettings = {
          url: `${domain}/finish-email-validation`,
          // url: `${domain}/finish-email-validation/${res.user.uid}`,
          handleCodeInApp: false
        }
        // console.log('actionCodeSettings', actionCodeSettings)
        await user.sendEmailVerification(actionCodeSettings)
        this.$root.$emit('showNavigationMessage', {
          message: '認証メールを再送信しました', showOK: true
        })
      } catch (e) {
        let message = 'エラーが発生しました'
        if (e.code === 'auth/too-many-requests') {
          message = '試行回数の上限を超えました。しばらくしてから再度お試しください'
        }
        console.error(e)
        this.$root.$emit('showNavigationMessage', {
          message, showOK: true
        })
      }
      await this.sleep(1000)
      this.isSendingVerificationEmail = false
    },
    formValidation () {
      const isEmail = (v) => {
        return /.+@.+\..+/.test(v)
      }
      if (!isEmail(this.email)) {
        this.enableSignIn = false
        return
      }
      if (this.$route.name === 'sign-in') {
        if (!this.email || !this.password) {
          this.enableSignIn = false
        } else {
          this.enableSignIn = true
        }
      } else if (this.$route.name === 'sign-up') {
        if (!this.name || !this.email || !this.password || !this.agreePolicy) {
          this.enableSignIn = false
        } else {
          this.enableSignIn = true
        }
      }
    },
    onStartSignIn () {
      this.$emit('toggleShowSocialSignIn')
      this.status = 'ask_email'
    },
    onCancel () {
      this.$emit('toggleShowSocialSignIn')
      this.status = 'start'
    }
  }
}
</script>